/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Partner_Manage_Storage_Downgrade_TitleInputs */



/**
* | output |
* | --- |
* | "Schedule change to {label}?" |
*
* @param {Partner_Manage_Storage_Downgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_downgrade_title = /** @type {((inputs: Partner_Manage_Storage_Downgrade_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Downgrade_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Änderung auf ${i?.label} planen?`)
	return /** @type {LocalizedString} */ (`Schedule change to ${i?.label}?`)
});